export const PAGES = {
  LOADING: "Loading",
  QR_CODE: "QRCode",
  WEBXR_ACTIVATION: "WebXRActivation",
  XR: "XR",
  AR: "AR",
  NO_DATA: "NO DATA",
};

export const APP_MODE = {
  ENGINE: "engine",
  RENDERER: "renderer",
};

export const AR_POSITION_SEEK = {
  NONE: "NONE", // Initial
  SEEK_START: "SEEK_START", // When AR is started but hit tests are yet to succeed
  SEEKING: "SEEKING", // Hit test results have started coming in, but user yet to select position
  SET_START: "SET_START", // User wants to set this position, but yet to save position
  SET_DONE: "SET_DONE", // Position has been selected and saved
  POSITION_RESET: "POSITION_RESET",
  RECENTER: "RECENTER",
};

export const AR_SUPPORT = {
  INITIALIZING: "AR_SUPPORT_Initializing",
  SUPPORTED: "AR_SUPPORT_Supported",
  NOT_SUPPORTED: "AR_SUPPORT_NotSupported",
};

export const AR_PLATFORM = {
  INITIALIZING: "AR_PLATFORM_Initializing",
  NONE: "AR_PLATFORM_NA",
  WEBXR: "AR_PLATFORM_Webxr",
  EIGHTHWALL: "AR_PLATFORM_8thwall",
  THREEJS: "VR_PLATFORM_THREEJS",
};

export const XR_MODES = {
  XR: "xr",
  AR: "ar",
};

export const Constants = {
  DEVICE_MOVE_FOR_POSITION: "Move your device in an 8 motion to calibrate",
};

export const SCENE_SOURCES = {
  R3F: "R3F",
  EIGHTHWALL: "EIGHTHWALL",
  SCENE_CONTROLLER: "SCENE_CONTROLLER",
};

export const ASSET_EVENTS = {
  ASSET_LOADED: "ASSET_LOADED",
  CONFIG_LOADED: "CONFIG_LOADED",
  CONFIG_NOT_LOADED: "CONFIG_NOT_LOADED",
};

export const SCENE_EVENTS = {
  SCENE_READY: "SCENE_READY",
};

export const ANIMATION_EVENTS = {
  ANIMATION_COMPLETE: "ANIMATION_COMPLETE",
  CENTER_SCALE_COMPLETE: "CENTER_SCALE_COMPLETE",
  ANIMATION_QUEUE_COMPLETE: "ANIMATION_QUEUE_COMPLETE",
};

export const AR_EVENTS = {
  INITIALIZED: "AR_INITIALIZED",
  WEBXR_EXCEPTION: "WEBXR_EXCEPTION",
};

export const THREEJS_NAMES = {
  AMBIENT_LIGHT: "AMBIENT_LIGHT",
  DIRECTIONAL_LIGHT: "DIRECTIONAL_LIGHT",
  SCENE_NAME: "SCENE",
  STATS: "STATS",
  AXES_HELPER: "AXES_HELPER",
  BOX_HELPER: "BOX_HELPER",
  MODEL: "MODEL",
  GRID_HELPER: "GRID_HELPER",
};

export const ASSET_TYPES = {
  GLTF: "GLTF",
  COMPRESSED_GLTF: "COMPRESSED_GLTF",
  TEXTURE: "TEXTURE",
  IMAGE: "IMAGE",
  SPRITE: "SPRITE",
  HDRI: "HDRI",
  CUBE_MAP: "CUBE_MAP",
};

export const ACTION_TYPES = {
  MATERIALS: "materials",
  CLIP_ANIMATION: "clipAnimation",
  DYNAMIC_ANIMATION: "dynamicAnimation",
  OPACITY: "opacity",
  BUTTON_SELECTOR: "button_selector",
  CORRELATION: "correlation",
};

export const ENGINE_COMPONENT_TYPES = {
  AMBIENT_LIGHT: "AMBIENT_LIGHT",
  DIRECTIONAL_LIGHT: "DIRECTIONAL_LIGHT",
  BACKGROUND_COLOR: "BACKGROUND_COLOR",
  BUTTON_SELECTOR: "BUTTON_SELECTOR",
  PLAY_CLIP_ANIMATION: "PLAY_CLIP_ANIMATION",
  INTERACTIVITY: "INTERACTIVITY",
  PRODUCT_INFO: "PRODUCT_INFO",
  EXPOSURE_COMPONENT: "EXPOSURE_COMPONENT",
  OPACITY_COMPONENT: "OPACITY_COMPONENT",
  MATERIALS_COMPONENT: "MATERIALS_COMPONENT",
  CLIP_ANIMATION_COMPONENT: "CLIP_ANIMATION_COMPONENT",
  DYNAMIC_ANIMATION_COMPONENT: "DYNAMIC_ANIMATION_COMPONENT",
  NAV_ICON: "NAV_ICON",
  CAMERA_COMPONENT: "CAMERA_COMPONENT",
  AXES_HELPERS: "AXES_HELPERS",
  ADD_SLOTS: "ADD_SLOTS",
  ENVIRONMENT_LIGHT: "ENVIRONMENT_LIGHT",
  ASPECT_RATIO_COMPONENT: "ASPECT_RATIO_COMPONENT",
  CORRELATION_COMPONENT: "CORRELATION_COMPONENT",
};

export const ACCORDION_LIST = {
  onClick: "Select Configurations",
  onUnClick: "Unselect Configurations",
  onLoad: "Onload Configurations",
  onSlot: "Slot Configurations",
};

export const ACTION_MAP = {
  [ENGINE_COMPONENT_TYPES.OPACITY_COMPONENT]: ACTION_TYPES.OPACITY,
  [ENGINE_COMPONENT_TYPES.MATERIALS_COMPONENT]: ACTION_TYPES.MATERIALS,
  [ENGINE_COMPONENT_TYPES.CLIP_ANIMATION_COMPONENT]:
    ACTION_TYPES.CLIP_ANIMATION,
  [ENGINE_COMPONENT_TYPES.DYNAMIC_ANIMATION_COMPONENT]:
    ACTION_TYPES.DYNAMIC_ANIMATION,
  [ENGINE_COMPONENT_TYPES.CORRELATION_COMPONENT]: ACTION_TYPES.CORRELATION,
};
export const APP_TRANSITIONS = {
  RENDERER_TRANSITION: "RENDERER_TRANSITION",
  ENGINE_TRANSITION: "ENGINE_TRANSITION",
};

export const SIDE_NAV_IDENTIFIERS = {
  PRODUCT_INFO: "product_info",
  GENERAL: "general",
  INTERACTIVITY: "3d_interactivity",
};

export const SIDE_NAV_ITEMS = [
  {
    label: "Product Info",
    icon: "InfoIcon",
    activeIcon: "InfoIconActive",
    id: SIDE_NAV_IDENTIFIERS.PRODUCT_INFO,
  },
  {
    label: "General",
    icon: "GeneralIcon",
    activeIcon: "GeneralIconActive",
    id: SIDE_NAV_IDENTIFIERS.GENERAL,
  },
  {
    label: "3D Interactivity",
    icon: "InteractivityIcon",
    activeIcon: "InteractivityIconActive",
    id: SIDE_NAV_IDENTIFIERS.INTERACTIVITY,
  },
];

export const WEB_VITALS_LABELS = {
  TTFB: "Time to First Byte(TTFB)",
  FCP: "First Contentful Paint(FCP)",
  LCP: "Largest Contentful Paint(LCP)",
  FID: "First Input Delay(FID)",
  CLS: "Cumulative Layout Shift(CLS)",
};

export const ICON_LABELS = {
  dimensionIcon: "Dimension Icon",
  colorChangeIcon: "Color Icon",
  fullEmptyIcon: "Full Empty Icon",
  openCloseIcon: "Open Close Icon",
  lightOnOffIcon: "Light On/Off Icon",
};

export const TEXTURE_MAP_LIST = {
  normalMap: "Normal Map",
  roughnessMap: "Roughness Map",
  metallicMap: "Metallic Map",
  lightMap: "Light Map",
  aoMap: "AO Map",
  emissiveMap: "Emissive Map",
  bumpMap: "Bump Map",
  alphaMap: "Alpha Map",
  displacementMap: "Displacement Map",
  map: "Default Map",
};

export const ASPECT_RATIO_LIST = [
  { label: "1:1", value: "1 / 1" },
  { label: "16:9", value: "16 / 9" },
  { label: "4:3", value: "4 / 3" },
  { label: "9:16", value: "9 / 16" },
  { label: "3:4", value: "3 / 4" },
];
